import { render, staticRenderFns } from "./processCard.vue?vue&type=template&id=39ed9242"
import script from "./processCard.vue?vue&type=script&lang=js"
export * from "./processCard.vue?vue&type=script&lang=js"
import style0 from "./processCard.vue?vue&type=style&index=0&id=39ed9242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports